import TypingHijack from '../components/TypingHijack'
import SimpleCharCountdown from '../components/SimpleCharCountdown'

export default class PublicationJobsSamples {
  constructor() {}

  update() {
    this.show()
  }

  show() {
    $(".js-char-editor").each((_, ele) => {
      new SimpleCharCountdown({ editor: $(ele) })
    });
    new TypingHijack();
  }
}
